import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ColorPickerModule } from 'ngx-color-picker';

import { AppColorSelectorComponent } from './app-color-selector/app-color-selector.component';
import { MenuHeroSliderComponent } from './menu-hero-slider/menu-hero-slider.component';
import { ThemeColorSelectorComponent } from './theme-color-selector/theme-color-selector.component';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  imports: [FormsModule, FontAwesomeModule, BrowserModule, CommonModule, ComponentsModule, ColorPickerModule, BrowserAnimationsModule],
  declarations: [MenuHeroSliderComponent, ThemeColorSelectorComponent, AppColorSelectorComponent],
  exports: [MenuHeroSliderComponent, ThemeColorSelectorComponent, AppColorSelectorComponent]
})
export class ConfigurationModule {}
